import { BeBox, BeButton, BeCheckBox, BeCol, BeCols, BeMenuField, BePage, BeRow, BeStack } from "@beos-css/react/index.ts";

export function BoxDemo() {
	return (
		<section id="demo-box">
			<h2>Box (BBox)</h2>
			<p>The R5 group box: a fancy etched groove (default) or a plain raised bevel, with the label notched into the top edge.</p>
			<BeRow wrap gap="row" pad="section" className="be-panel be-fit">
				<BeBox label="Appearance">
					<BeStack gap="inset" align="start">
						<BeCheckBox defaultChecked>Anti-alias text</BeCheckBox>
						<BeCheckBox>Show replicants</BeCheckBox>
					</BeStack>
				</BeBox>
				<BeBox label="Plain" border="plain">
					A plain single-bevel box.
				</BeBox>
				<BeBox border="plain">A plain box without a label.</BeBox>
			</BeRow>
			<BeRow wrap gap="row" pad="section" className="be-panel be-fit">
				<BeBox
					label={
						<BeMenuField defaultValue="wav">
							<option value="wav">WAV Format</option>
							<option value="aiff">AIFF Format</option>
							<option value="raw">Raw Audio</option>
						</BeMenuField>
					}
				>
					A control in the label notch, like BBox::SetLabel(BView*).
				</BeBox>
				<BeBox label="Logging" accessory={<BeCheckBox defaultChecked>Enabled</BeCheckBox>}>
					A right-hand accessory slot over the top edge.
				</BeBox>
			</BeRow>
			<h3>a label and an accessory share the header</h3>
			<p>
				Both sit in the <code>&lt;legend&gt;</code>, so the label yields and clips at the notch rather than running underneath the
				accessory. Drag the window narrower to watch it give way. The accessory takes no height of its own — the label sets the header, as{" "}
				<code>BBox::GetHeaderInfo</code> does — so a taller control overhangs the band instead of deepening the box.
			</p>
			<BeRow wrap gap="row" pad="section" className="be-panel be-fit">
				<BeBox label="Shadow and margin preview settings" accessory={<BeCheckBox defaultChecked>disable</BeCheckBox>}>
					A label too long for its box.
				</BeBox>
				<BeBox label="Layers" accessory={<BeButton>Add layer</BeButton>}>
					An accessory taller than the label.
				</BeBox>
			</BeRow>
			<h3>fill — matching heights across a row</h3>
			<p>
				A grid cell is stretched to its row already; a fieldset inside it is not, so boxes with different amounts of content come out
				ragged. <code>fill</code> takes the block axis the cell is offering — the same "take the box you are given" the prop means on
				BeScrollView, BeWindow and BeTabView.
			</p>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="section">
					<BeCols>
						<BeCol span={8}>
							<BeBox label="Without fill">One line.</BeBox>
						</BeCol>
						<BeCol span={8}>
							<BeBox label="Without fill">
								<BeStack gap="inset" align="start">
									<span>Three lines of content,</span>
									<span>so this box is the taller</span>
									<span>of the two in its row.</span>
								</BeStack>
							</BeBox>
						</BeCol>
					</BeCols>
					<BeCols>
						<BeCol span={8}>
							<BeBox fill label="With fill">
								One line.
							</BeBox>
						</BeCol>
						<BeCol span={8}>
							<BeBox fill label="With fill">
								<BeStack gap="inset" align="start">
									<span>Three lines of content,</span>
									<span>and the short box beside it</span>
									<span>now matches this height.</span>
								</BeStack>
							</BeBox>
						</BeCol>
					</BeCols>
				</BeStack>
			</BePage>
		</section>
	);
}
